import getSubstringBeforeFindString from '../helpers/getSubstringBeforeFindString'
import getSubstringAfterFindString from '../helpers/getSubstringAfterFindString'
import isEmpty from '../helpers/isEmpty'
//====================================================================
// detailed fields arrays by item type (tab suffix)
//-------------------------------------------------
const detailFieldsByTabSuffix = {
  //--------
  // common
  //--------
  common: [
    'rowNumber',
    'name',
    'short_description', // e.g. my nice sword
    'fill0',
    'held_image',
    'located_image',
    'stored_image',
    'worn_image',
    'equipped_image',
    'attached_image',
    'magic_image',
    'fill1',
    'tally_qty',
    'adjust_image',
    'tot_enc',
    'unit_name',
    'max_unit_count',
    'cur_unit_count',
    // flags
    'fill3',
    'fill4',
    'held_yes',
    'starter_image',
    'tallyable_image',
    'countable_image',
    'wearable_image',
    'storeable_image',
    'storage_image',
    'attachable_image',
    'attach_point_image',
  ],
  //------------
  // containers
  //------------
  containers: [
    'fill2',
    'attachment_count',
    'attachment_items_image',
    'contents_image',
    'container_capacity',
    'container_size_short',
    'contents_count_total',
    'contents_enc',
  ],
  //--------
  // armour
  //--------
  armour: ['fill3', 'coverage', 'ap', 'hp', 'layer', 'pwr_storage', 'dex_pen'],
  //---------------
  // melee weapons
  //---------------
  // NOTE: damage column is "damage_dice" in headings
  melee_weapons: [
    'fill3',
    'damage_dice',
    'ap',
    'hp',
    'pwr_storage',
    'impale_image',
    'usable_image',
  ],
  //---------------
  // ranged weapons
  //---------------
  ranged_weapons: [
    'fill3',
    'damage_dice',
    'ap',
    'hp',
    'pwr_storage',
    'load',
    'range',
    'usable_image',
  ],
  //-----------
  // artefacts
  //-----------
  artefacts: [
    'short_description',
    'value',
    'image',
    'base_item',
    'fill3',
    'pwr_storage',
    'rune_name',
    'artefact_type',
    'material',
    'quality',
    'age',
    'race',
  ],
  healing: ['healing_type', 'recovers', 'delay'],
  poison: ['poison_type', 'pot', 'effect', 'delay', 'duration', 'resist', 'damage_dice'],
  specialist: ['delay', 'damage_dice', 'duration', 'resist'],
}

function collapseUnifiedWornColumn(fields, tab_suffix) {
  if (tab_suffix === 'armour') {
    return fields
  }

  if (fields.includes('worn_image') && fields.includes('equipped_image')) {
    return fields.filter((field) => field !== 'equipped_image')
  }

  return fields
}
//====================================================================
// get item detail cols
//----------------------
export default function getItemDetailCols(active_tab, headings) {
  console.log('-----------------------')
  console.log('IN getItemDetailCols active_tab:', active_tab)
  //----------
  // declares
  //----------
  let colNumbers = []
  let fields = []
  //------------------
  // check active tab
  //------------------
  let tab_prefix = getSubstringBeforeFindString(active_tab, '-')
  if (tab_prefix !== 'items') {
    console.error('*** getItemDetailCols - Invalid sheet:', active_tab)
    return colNumbers
  }
  //------------------------
  // set field cols to show
  //------------------------
  const tab_suffix = getSubstringAfterFindString(active_tab, 'items-')
  //-----------------------
  // guard have tab suffix
  //-----------------------
  if (isEmpty(tab_suffix)) {
    console.warn(
      '*** getItemDetailCols - No tab suffix found in active_tab:',
      active_tab,
      ' - defaulting to common',
    )
  }
  //===========================================================================================================
  // ALL
  //-----
  if (tab_suffix === 'all') {
    const base = detailFieldsByTabSuffix.common
    //-----------------
    // start from base
    //-----------------
    fields = [...base]
    if (!fields.includes('usable_image')) {
      const heldIdx = fields.indexOf('held_image')
      const insertIdx = heldIdx !== -1 ? heldIdx + 1 : fields.length
      fields.splice(insertIdx, 0, 'usable_image')
    }
    if (!fields.includes('campaign_ref')) {
      fields.push('campaign_ref')
    }
    //--------------------------------
    // ensure type / equipment type
    //--------------------------------
    if (!fields.includes('type')) {
      const nameIdx = fields.indexOf('name')
      const insertAt = nameIdx !== -1 ? nameIdx + 1 : 1
      fields.splice(insertAt, 0, 'type')
    }
    if (!fields.includes('equipment_type')) {
      const shortIdx = fields.indexOf('short_description')
      const insertAt = shortIdx !== -1 ? shortIdx + 1 : 3
      fields.splice(insertAt, 0, 'equipment_type')
    }
    //------------------------------------------------
    // add container details if not already present
    //------------------------------------------------
    if (!fields.includes('contents_image')) {
      const insertAt = fields.indexOf('fill1') + 1 || fields.length
      fields.splice(
        insertAt,
        0,
        'fill2',
        'attachment_count',
        'attachment_items_image',
        'contents_image',
        'container_capacity',
        'container_size_short',
        'contents_count_total',
        'contents_enc',
      )
    }
    //-----------------
    // remove equipped
    //-----------------
    if (fields.includes('equipped_image')) {
      fields = fields.filter((a) => a !== 'equipped_image')
    }
    //===========================================================================================================
    // EQUIPMENT
    //-----------
  } else if (tab_suffix === 'equipment') {
    const base = detailFieldsByTabSuffix.common
    //-----------------
    // start from base
    //-----------------
    fields = [...base]
    //------------------------------------------------
    // add container details if not already present
    //------------------------------------------------
    if (!fields.includes('contents_image')) {
      const insertAt = fields.indexOf('fill1') + 1 || fields.length
      fields.splice(
        insertAt,
        0,
        'fill2',
        'attachment_count',
        'attachment_items_image',
        'contents_image',
        'container_capacity',
        'container_size_short',
        'contents_count_total',
        'contents_enc',
      )
    }
    //--------------------------------
    // ensure equipment type column
    //--------------------------------
    if (!fields.includes('equipment_type')) {
      const shortIdx = fields.indexOf('short_description')
      const insertAt = shortIdx !== -1 ? shortIdx + 1 : 3
      fields.splice(insertAt, 0, 'equipment_type')
    }
    //===========================================================================================================
    // ARMOUR
    //--------
  } else if (tab_suffix === 'armour') {
    const base = detailFieldsByTabSuffix.common
    //-----------------
    // start from base
    //-----------------
    fields = [...base]
    //------------------------------------------------
    // add armour details if not already present
    //------------------------------------------------
    const armourExtras = detailFieldsByTabSuffix.armour.filter((f) => f !== 'fill3')
    for (const f of armourExtras) {
      if (!fields.includes(f)) {
        const fill3Idx = fields.indexOf('fill3')
        const insertAt = fill3Idx !== -1 ? fill3Idx + 1 : fields.length
        fields.splice(insertAt, 0, f)
      }
    }
    //------------------------------
    // remove tally qty/adjust/worn
    //------------------------------
    if (
      fields.includes('tally_qty') ||
      fields.includes('adjust_image') ||
      fields.includes('worn_image')
    ) {
      fields = fields.filter((a) => a !== 'tally_qty' && a !== 'adjust_image' && a !== 'worn_image')
    }
    //===========================================================================================================
    // MELEE WEAPONS
    //---------------
  } else if (tab_suffix === 'melee-weapon') {
    const base = detailFieldsByTabSuffix.common
    //-----------------
    // start from base
    //-----------------
    fields = [...base]
    //------------------------------------------------------
    // add melee weapon details if not already present
    //------------------------------------------------------
    const meleeExtras = detailFieldsByTabSuffix.melee_weapons.filter((f) => f !== 'fill3')
    for (const f of meleeExtras) {
      if (!fields.includes(f)) {
        const fill3Idx = fields.indexOf('fill3')
        const insertAt = fill3Idx !== -1 ? fill3Idx + 1 : fields.length
        fields.splice(insertAt, 0, f)
      }
    }
    //------------------------------
    // remove tally qty/adjust
    //------------------------------
    if (fields.includes('tally_qty') || fields.includes('adjust_image')) {
      fields = fields.filter((a) => a !== 'tally_qty' && a !== 'adjust_image')
    }
    //===========================================================================================================
    // RANGED WEAPONS
    //----------------
  } else if (tab_suffix === 'ranged-weapon') {
    const base = detailFieldsByTabSuffix.common
    //-----------------
    // start from base
    //-----------------
    fields = [...base]
    //--------------------------------------------------
    // add ranged weapon details if not already present
    //--------------------------------------------------
    const rangedExtras = detailFieldsByTabSuffix.ranged_weapons.filter((f) => f !== 'fill3')
    for (const f of rangedExtras) {
      if (!fields.includes(f)) {
        const fill3Idx = fields.indexOf('fill3')
        const insertAt = fill3Idx !== -1 ? fill3Idx + 1 : fields.length
        fields.splice(insertAt, 0, f)
      }
    }
    //------------------------------
    // remove tally qty/adjust
    //------------------------------
    if (fields.includes('tally_qty') || fields.includes('adjust_image')) {
      fields = fields.filter((a) => a !== 'tally_qty' && a !== 'adjust_image')
    }
    //===========================================================================================================
    // ARTEFACTS
    //----------------
  } else if (tab_suffix === 'artefact') {
    const base = detailFieldsByTabSuffix.common
    //-----------------
    // start from base
    //-----------------
    fields = [...base]
    if (!fields.includes('campaign_ref')) {
      fields.push('campaign_ref')
    }
    //---------------------------------------------
    // add artefact details if not already present
    //---------------------------------------------
    const artefactExtras = detailFieldsByTabSuffix.artefacts.filter((f) => f !== 'fill3')
    for (const f of artefactExtras) {
      if (!fields.includes(f)) {
        const fill3Idx = fields.indexOf('fill3')
        const insertAt = fill3Idx !== -1 ? fill3Idx + 1 : fields.length
        fields.splice(insertAt, 0, f)
      }
    }
  } else if (tab_suffix === 'healing' || tab_suffix === 'poison' || tab_suffix === 'specialist') {
    const base = detailFieldsByTabSuffix.common
    const tabExtras = detailFieldsByTabSuffix[tab_suffix] || []
    fields = [...base]

    const shortDescIdx = fields.indexOf('short_description')
    const insertAt = shortDescIdx !== -1 ? shortDescIdx + 1 : fields.length
    fields.splice(insertAt, 0, ...tabExtras)
  } else {
    //===========================================================================================================
    // OTHERWISE
    //-----------
    fields = detailFieldsByTabSuffix[tab_suffix] || detailFieldsByTabSuffix.common
  }
  fields = collapseUnifiedWornColumn(fields, tab_suffix)
  //--------------------------------
  // get headings idx for col names
  //--------------------------------
  for (let k = 0; k < fields.length; k++) {
    const idx = headings.findIndex((a) => a.field === fields[k])
    if (idx !== -1) {
      colNumbers.push(idx)
    }
  }
  return colNumbers
}
